<script>
    import { pencil, save } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';
    import TextField from "../form/TextField.svelte";
    import Button from "./Button.svelte";
    import Notification from "../Notification.svelte";
    import { client, gql } from "../../GraphQL.svelte";

    export let content = "";
    export let editable = false;
    export let projectId;

    let editing = false;
    let editedContent = content;
    let saveRequest;
    let saveErrorMsg;
    let saveSuccessMsg;

    $: saving = !!saveRequest;
    $: changed = content != editedContent;

    function editIt() {
        editing = true;
    }

    function stopEditing() {
        setTimeout(() => {
            if (!saving) {
                editing = false;
            }
        }, 1000);
    }

    function saveIt() {
        // perform mutation
        saveRequest = client.mutate({
            variables: {
                project: {
                    id: projectId,
                    description: editedContent
                }
            },
            mutation: gql`
                mutation($project: UpdateProjectInput!) {
                    updateProject(project: $project) {
                        description
                    }
                }
            `,
        });

        // success
        saveRequest.then(res => {
            saveRequest = null;
            editing = false;
            saveErrorMsg = null;
            saveSuccessMsg = "Successfully saved description";
            content = editedContent;
        });

        // error
        saveRequest.catch(err => {
            console.error(err);
            saveErrorMsg = "There was an error trying to save the description";
            saveSuccessMsg = null;
            editing = false;
            saveRequest = null;
        });
    }
</script>

<div class="description-editable">
    {#if !editing}
        {content}
    {:else}
        <input type="text"
               bind:value={editedContent}
               autofocus
               disabled={saving}
               on:blur={stopEditing}
        />
    {/if}

    {#if !editable}
        <!-- do nothing -->
    {:else if !editing}
        <button on:click={editIt} class="action-button description-edit-button">
            <Icon data={pencil}/>
        </button>
    {:else}
        <Button on:click={saveIt} disabled={saving || !changed} class="action-button description-save-button">
            <Icon data={save} style="font-weight: 800"/>
        </Button>
    {/if}
</div>

<Notification type="error" message={saveErrorMsg} />
<Notification type="success" message={saveSuccessMsg} />

<style>
    .description-edit-button {
        background: 0;
        border: 0;
    }
</style>